import { Row, Checkbox, Button, Col, Rate, Slider, Divider } from 'antd';
import * as React from 'react';
import { observer } from 'mobx-react';

import { FormatService } from 'src/core/services/format.service';
import { CollapseCard } from '../../shared/collapse-card.view';
import { ZuluIcon } from 'src/app/shared/icon';

interface SearchFacetProps extends ComponentViewProps<{ facets: Facet[] }> {
	onFacetSearchClick?: () => void;
	formatService: FormatService;
}

interface BreadcrumbItem {
	heading: Heading;
	facet: Facet;
	text: JSX.Element;
	breadcrumbName: string;
	onClick: () => void;
	path: string;
}

interface SearchFacetState {
	activeView?: { [facetName: string]: string };
	breadcrumb: BreadcrumbItem[];
}

@observer
export class SearchFacetView extends React.Component<SearchFacetProps, SearchFacetState> {
	constructor(props: Readonly<SearchFacetProps>) {
		super(props);
		let activesView = {};
		for (let facet of this.props.model.facets)
			activesView[facet.name] = "collapse"
		this.state = { activeView: activesView, breadcrumb: [] };
	}

	private renderFacets = (facets: Facet[]): JSX.Element => {
		let facetView = [];
		const { activeView, breadcrumb } = this.state;
		for (const facet of facets) {
			facetView.push(
				<CollapseCard
					key={facet.name}
					keyTitle={facet.name}
					title={facet.name}
					initialCollapseState={true}
					onToggleCollapse={this.toggleCollapse}
					extra={<ZuluIcon type={facet.icon || "book"} />}
				>
					{facets.length > 0 && activeView[facet.name] === 'facet' && this.renderHeadings(facet)}
				</CollapseCard>
			);
		}
		return (
			<React.Fragment>
				{facetView}
				<Divider />
				<Row gutter={16}>
					{breadcrumb && breadcrumb.map(this.renderBreadcrumbItem)}
				</Row>
				<Divider />
			</React.Fragment>
		);
	}

	private renderBreadcrumbItem(breadcrumbItem: BreadcrumbItem, index: number, array: object[]) {
		return (
			<Col span={24} className={array.length === index + 1 ? "" : "mb-1"} key={breadcrumbItem.breadcrumbName}>
				<Button
					key={breadcrumbItem.breadcrumbName}
					type='dashed'
					block={true}
					onClick={() => breadcrumbItem.onClick()}
				>
					{breadcrumbItem.text}
					<ZuluIcon type='close' />
				</Button>
			</Col>
		);
	}

	private closeItem = (key: string) => {
		let breadcrumb = [...this.state.breadcrumb];
		const index = breadcrumb.findIndex(item => item.breadcrumbName == key);
		if (index != -1) {
			breadcrumb.splice(index, 1);
			const facets = this.getFacet(breadcrumb);
			this.props.model.facets = facets;
			this.setState({ breadcrumb: breadcrumb });
			this.props.onFacetSearchClick();
		}
	}

	private toggleCollapse = (collapsed: boolean, facetName: string) => {
		const { activeView } = this.state;
		activeView[facetName] = collapsed ? 'facet' : 'collapse';
		this.setState({
			activeView: activeView
		});
	}

	private renderHeadingLabel = (facet: Facet, heading: Heading): JSX.Element => {
		if (facet.name == "Star rating")
			return (
				<React.Fragment>
					<Rate disabled={true} defaultValue={parseInt(heading.value)} count={5} /> <span>{`(${heading.matchCount})`}</span>
				</React.Fragment>
			);
		if (facet.name == "Check In" || facet.name == "Check Out") {
			let value = heading.value;
			if (heading.value.startsWith("Equal to ")) {
				let date = heading.rangeDate.value;
				value = `Equal to ${this.props.formatService.toString("small-date-time", date)}`;
			} else if (heading.value.startsWith("Greater than ")) {
				let date = heading.rangeDate.value;
				value = `Greater than ${this.props.formatService.toString("small-date-time", date)}`;
			} else if (heading.value.startsWith("Greater an equal than ")) {
				let date = heading.rangeDate.value;
				value = `Greater an equal than  ${this.props.formatService.toString("small-date-time", date)}`;
			} else if (heading.value.startsWith("Less than ")) {
				let date = heading.rangeDate.value;
				value = `Less than ${this.props.formatService.toString("small-date-time", date)}`;
			} else if (heading.value.startsWith("Less an equal than ")) {
				let date = heading.rangeDate.value;
				value = `Less an equal than  ${this.props.formatService.toString("small-date-time", date)}`;
			} else if (heading.value.includes(" to ")) {
				let date1 = heading.rangeDate.minValue;
				let date2 = heading.rangeDate.maxValue;
				value = `${this.props.formatService.toString("small-date-time", date1)} to ${this.props.formatService.toString("small-date-time", date2)}`;
			}
			return <span>{`${value} (${heading.matchCount})`}</span>;
		}

		return <span>{`${heading.value} (${heading.matchCount})`}</span>;
	}

	private onChangeSlider = (value) => {
		const { breadcrumb } = this.state;
		let facetPrice = this.props.model.facets.find(x => x.name.startsWith("Prices"));
		let maximun = Math.ceil(facetPrice.headings[facetPrice.headings.length - 1].rangeDecimal.maxValue);
		let minimun = Math.floor(facetPrice.headings[0].rangeDecimal.minValue);
		let heading = (value[0] == value[1]) ? minimun == value[0] : minimun == value[0] && maximun == value[1];
		let format = facetPrice.headings[0].rangeDecimal.format;
		if (heading == false) {
			for (let heading of facetPrice.headings)
				heading.isChecked = false;
			let heading = {
				value: `${value[0]} to ${value[1]}`,
				valueField: null,
				matchCount: 0,
				subHeading: [],
				isChecked: true,
				rangeDate: null,
				rangeDecimal: {
					format: format,
					maxValue: value[1],
					operator: 5,
					minValue: value[0],
					value: null
				}
			};
			facetPrice.headings.push(heading);
			breadcrumb.push({
				heading: heading,
				facet: facetPrice,
				text: this.renderHeadingLabel(facetPrice, heading),
				breadcrumbName: heading.value,
				onClick: () => { this.closeItem(heading.value) },
				path: null
			});
			this.setState({ breadcrumb: breadcrumb });
			this.props.onFacetSearchClick();
		}
	}

	private addSliderPrice(facet: Facet, headingView: any[]) {
		if (facet.name.startsWith("Prices") && facet.headings.length > 0) {
			let maximun = Math.ceil(facet.headings[facet.headings.length - 1].rangeDecimal.maxValue);
			let minimun = Math.floor(facet.headings[0].rangeDecimal.minValue);
			let values: [number, number] = [minimun, maximun];
			headingView.unshift(
				<Row gutter={16} key={facet.name}>
					<Col xs={24}>
						<Slider
							className="mr-3 ml-3"
							range
							value={values}
							onChange={this.onChangeSlider}
							min={minimun}
							max={maximun}
						/>
					</Col>
				</Row>
			);
		}
	}

	desCheckAll = (headings: Heading[]) => {
		headings.forEach((h) => {
			h.isChecked = false;
			if (h.subHeading) {
				this.desCheckAll(h.subHeading)
			}
		});
	}

	getFacet = (breadcrumbs: BreadcrumbItem[]): Facet[] => {
		let facets: Facet[] = [];
		const groups = new Map<Facet, Heading[]>();
		breadcrumbs.forEach((m) => {
			if (m.facet) {
				let g = groups.get(m.facet);
				if (g == null) {
					groups.set(m.facet, g = [m.heading]);
				} else {
					g.push(m.heading);
				}
			}
		});
		groups.forEach((headings, facet) => {
			facet.headings = headings;
			facets.push(facet);
		});
		return facets;
	}

	renderCheckNodes = (data: Heading[], facet: Facet) => {
		const checkStyle = {
			padding: '10px'
		};

		return data.map((item) => {
			if (item.subHeading) {
				return (
					<React.Fragment key={item.value}>
						<Row gutter={16}>
							<Col span={24}>
								<Checkbox style={checkStyle} checked={item.isChecked} onChange={(e) => {
									let facets = [...this.props.model.facets];
									let breadcrumb = [...this.state.breadcrumb];
									if (facet.multiple == false) {
										this.desCheckAll(facet.headings);
									}
									item.isChecked = e.target.checked;
									if (item.isChecked) {
										breadcrumb.push({
											heading: item,
											facet: facet,
											text: this.renderHeadingLabel(facet, item),
											breadcrumbName: item.value,
											onClick: () => { this.closeItem(item.value) },
											path: null
										});
									}
									else {
										const index = breadcrumb.findIndex(b => b.breadcrumbName == item.value);
										if (index != -1) {
											breadcrumb.splice(index, 1);
										}

									}
									if (facet.multiple == false || facet.headings.every(h => !h.isChecked)) {
										facets = this.getFacet(breadcrumb);
										this.props.model.facets = facets;
										this.props.onFacetSearchClick();
									}
									this.setState({ breadcrumb: breadcrumb });
								}} >{this.renderHeadingLabel(facet, item)} </Checkbox>
							</Col>

						</Row>
						<Row gutter={16}>
							<Col span={22} offset={2}>
								{this.renderCheckNodes(item.subHeading, facet)}
							</Col>
						</Row>
					</React.Fragment>
				);
			}
			return (
				<Row gutter={16} key={item.value}>
					<Col span={24}>
						<Checkbox
							style={checkStyle}
							checked={item.isChecked}
							onChange={(e) => {
								let facets = [...this.props.model.facets];
								let breadcrumb = [...this.state.breadcrumb];
								if (facet.multiple == false) {
									this.desCheckAll(facet.headings);
								}
								item.isChecked = e.target.checked;
								if (item.isChecked) {

									breadcrumb.push({
										heading: item,
										facet: facet,
										text: this.renderHeadingLabel(facet, item),
										breadcrumbName: item.value,
										onClick: () => { this.closeItem(item.value) },
										path: null
									});
								}
								else {
									const index = breadcrumb.findIndex(b => b.breadcrumbName == item.value);
									if (index != -1) {
										breadcrumb.splice(index, 1);

									}
								}
								if (facet.multiple == false || facet.headings.every(h => !h.isChecked)) {
									facets = this.getFacet(breadcrumb);
									this.props.model.facets = facets;
									this.props.onFacetSearchClick();
								}
								this.setState({ breadcrumb: breadcrumb });
							}}
						>
							{this.renderHeadingLabel(facet, item)}
						</Checkbox>
					</Col>
				</Row>
			);
		});
	}

	private renderHeadings = (facet: Facet): React.ReactNode => {
		let headingView = this.renderCheckNodes(facet.headings, facet);
		this.addSliderPrice(facet, headingView);
		if (facet.multiple == true) {
			headingView.push(
				<Row key={facet.name}>
					<Col xs={24}>
						<Button
							key="filter"
							type="primary"
							onClick={() => {
								let breadcrumb = [...this.state.breadcrumb];
								let facets = this.getFacet(breadcrumb);
								this.props.model.facets = facets;
								this.props.onFacetSearchClick();
								this.setState({ breadcrumb: breadcrumb });
							}}
							disabled={facet.headings.every(h => !h.isChecked)}
						>
							Search
						</Button>
					</Col>
				</Row>
			);
		}

		return headingView;
	}

	public render(): JSX.Element {
		if (this.props.model.facets != null && this.props.model.facets.length > 0 && this.props.model.facets.some(f => f.headings.length > 0)) {
			return this.renderFacets(this.props.model.facets)
		} else {
			return null;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/search/search-facets.view.tsx